// extracted by mini-css-extract-plugin
export default {"labelFont":"400 14px Montserrat,sans-serif","emptyLabelFont":"12px Montserrat,sans-serif"};